exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fieldForTest {\n  position: absolute;\n  bottom: 100%;\n  right: 100%; }\n\n.timer-resendSMS {\n  text-align: center;\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  text-align: center;\n  color: #727272; }\n  .timer-resendSMS > img {\n    width: 16px;\n    height: 19px; }\n\n.Continue-SMS-button {\n  margin-top: 30px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Phone/components/PhoneConfirmation/styles.scss
// module id = 1292
// module chunks = 0